import { createRoot } from 'react-dom/client'
import { App } from '@/components/App'
import { AuthenticatedDataProviders } from '@/components/billing/AuthenticatedDataProviders'
import { Toaster } from '@/components/ui/sonner'
import { SessionProvider } from '@/lib/session-context'

function initReactApp() {
  const container = document.getElementById('react-root')
  if (!container) return

  const bootstrap = window.__SENTINEL__ ?? { currentUser: null, csrfToken: null }
  createRoot(container).render(
    <SessionProvider initial={bootstrap}>
      <AuthenticatedDataProviders>
        <App />
        <Toaster position="top-center" richColors />
      </AuthenticatedDataProviders>
    </SessionProvider>,
  )
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReactApp)
} else {
  initReactApp()
}
